module.exports = __webpack_public_path__ + "static/media/Vector.f0277e71.png";